(function () {
    'use strict';

    angular.module('core')
        .directive('focusMe', function ($timeout) {
            return {
                link: function (scope, element, attrs) {
                    var value = attrs.focusMe == 'true';
                    if (value) {
                        $timeout(function () {
                            // If element is wrapping the input focus obj, we need to find real focus obj
                            if (element.find('input').length > 0) {
                                element.find('input')[0].focus();
                            } else {
                                element[0].focus();
                            }
                        });
                    }
                }
            };
        });

})();
